import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "payment-info-window" }
const _hoisted_2 = {
  key: 0,
  class: "payment-info-loader"
}
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "stripe-card",
  id: "stripe-frame"
}, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "error" }
const _hoisted_6 = { class: "popup-buttons" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "payment-info-popup",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode($setup["Loader"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.withdraw ? "New Account" : "New Payment Method"), 1 /* TEXT */),
      _createVNode($setup["VTextField"], {
        class: "payment-name",
        label: "Nickname (Optional)",
        modelValue: $setup.paymentNickname,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.paymentNickname) = $event)),
        maxLen: "20"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString($setup.errorMessage), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "borderless cancel",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('close')))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "primary finish",
          disabled: $setup.stripeFail,
          onClick: $setup.confirmSetupIntent
        }, "Finish", 8 /* PROPS */, _hoisted_7)
      ])
    ])
  ]))
}